import { Module } from 'cerebral'
import selectNode from './chains/selectNode'
import toggleNodeExpanded from './chains/toggleNodeExpanded'
import showTreeContextMenu from './chains/showTreeContextMenu'
import hideTreeContextMenu from './chains/hideTreeContextMenu'
import expandNode from './chains/expandNode'
import showNodePanel from './chains/showNodePanel'
import onChangeNodeName from './chains/onChangeNodeName'
import saveNode from './chains/saveNode'
import closeNode from './chains/closeNode'
import prepareRemoveNode from './chains/prepareRemoveNode'
import deleteNode from './chains/deleteNode'
import setListType from './chains/setListType'
import clearDate from './chains/clearDate'
import changeDate from './chains/changeDate'
import onNodeEnter from './chains/onNodeEnter'
import onNodeLeave from './chains/onNodeLeave'
import toggleGroup from './chains/toggleGroup'
import moveNode from './chains/moveNode'
import onBeforeMoveNode from './chains/onBeforeMoveNode'
import clearRebuild from './chains/clearRebuild'
import toggleMenuOpen from './chains/toggleMenuOpen'
import revokeMove from './chains/revokeMove'
import enterHoverTreeMenu from './chains/enterHoverTreeMenu'
import leaveHoverTreeMenu from './chains/leaveHoverTreeMenu'

export default Module(({ name, path, controller }) => {
  return {
    state: {
      tree: {
        open: true,
        hover: false,
        transition: false
      },
      selectedNode: {
        id: null,
        path: null
      },
      moveAlertTime: {
        date: null,
        millis: 1000 * 60 * 5 // 5 min
      },
      showMenuToggle: false,
      deleteNode: null,
      expandedList: {},
      selectedList: {},
      nodes: {},
      contextMenu: {},
      listType: 'FOLDER',
      drop: {},
      panel: {
        show: false,
        path: null,
        name: {
          value: ''
        }
      },
      rebuildTree: false
    },
    signals: {
      selectNode,
      toggleNodeExpanded,
      showTreeContextMenu,
      hideTreeContextMenu,
      expandNode,
      showNodePanel,
      onChangeNodeName,
      saveNode,
      closeNode,
      prepareRemoveNode,
      deleteNode,
      setListType,
      clearDate,
      changeDate,
      onNodeEnter,
      onNodeLeave,
      toggleGroup,
      moveNode,
      onBeforeMoveNode,
      clearRebuild,
      toggleMenuOpen,
      revokeMove,
      enterHoverTreeMenu,
      leaveHoverTreeMenu
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/Node/index.js